import { ALL_CARDS } from './cardDefinitions.generated';

const BY_ID = new Map(ALL_CARDS.map((c) => [c.id, c]));

export function defFor(cardId) {
  const def = BY_ID.get(cardId);
  if (!def) throw new Error(`Unknown card id: ${cardId}`);
  return def;
}
